import axios from "axios";
import { getApiUrl } from "./urlHelper.js";

const api = axios.create({
  baseURL: getApiUrl("/api"),  // 🔁 Backend URL
  withCredentials: true,
});

// हर request के साथ token भेजना (fallback for older clients)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 401 Unauthorized
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Session expired or invalid token
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
